import React from 'react';
import * as Routes from '|/app/steps/routes';
import { StepName } from '../services';

type StepRouteProps = {
  GetDashboardAndRouteToNextStep: (_?: boolean) => void;
  GetDashboardBackgroundLoading: () => {
    type: string;
    payload: () => Promise<void>;
  };
};

const routeNameComponentLookup: {
  [key in StepName]: {
    component: React.FC<StepRouteProps>;
    completionTimeEstimate?: number;
  };
} = {
  [StepName.PersonalDetails]: {
    component: Routes.PersonalDetailsRoute,
    completionTimeEstimate: 3
  },
  [StepName.TradeIn]: {
    component: Routes.TradeInRoute,
    completionTimeEstimate: 4
  },
  [StepName.CoF]: {
    component: Routes.PaymentOptionsRoute,
    completionTimeEstimate: 2
  },
  [StepName.Gap]: {
    component: Routes.GapRoute,
    completionTimeEstimate: 2
  },
  [StepName.PickupDelivery]: {
    component: Routes.TransferMethodRoute,
    completionTimeEstimate: 1
  },
  [StepName.VSC]: {
    component: Routes.CarvanaProtectionRoute,
    completionTimeEstimate: 1
  },
  [StepName.DL]: {
    component: Routes.DriversLicenseRoute,
    completionTimeEstimate: 4
  },
  [StepName.Identity]: {
    component: Routes.IdentityRoute,
    completionTimeEstimate: 2
  },
  [StepName.Payment]: {
    component: Routes.DownPaymentRoute,
    completionTimeEstimate: 5
  },
  [StepName.Autopay]: {
    component: Routes.AutopayEnrollment,
    completionTimeEstimate: 5
  },
  [StepName.Review]: {
    component: Routes.ReviewOrderRoute,
    completionTimeEstimate: 2
  },
  [StepName.IdentityVerification]: {
    component: Routes.IdentityVerificationRoute,
    completionTimeEstimate: 2
  },
  [StepName.BAV]: {
    component: Routes.BankAccountVerificationRoute,
    completionTimeEstimate: 2
  },
  [StepName.Income]: {
    component: Routes.IncomeInformationRoute,
    completionTimeEstimate: 5
  },
  [StepName.Address]: {
    component: Routes.ResidencyInformationRoute,
    completionTimeEstimate: 5
  },
  [StepName.TradeVerification]: {
    component: Routes.TradeDocumentationRoute,
    completionTimeEstimate: 5
  },
  [StepName.AdditionalIncome]: {
    component: Routes.AdditionalIncomeRoute,
    completionTimeEstimate: 5
  },
  [StepName.CaseSubmission]: {
    component: Routes.CompleteDocUploadRoute,
    completionTimeEstimate: 1
  },
  [StepName.Schedule]: {
    component: Routes.TransferScheduleRoute,
    completionTimeEstimate: 1
  },
  [StepName.Insurance]: {
    component: Routes.InsuranceOptionsRoute,
    completionTimeEstimate: 3
  },
  [StepName.Dashboard]: {
    component: Routes.OrderPlacedRoute,
    completionTimeEstimate: 1
  },
  [StepName.CleanVehicleTaxCredit]: {
    component: Routes.EvTaxCreditRoute,
    completionTimeEstimate: 1
  }
};

export default routeNameComponentLookup;
